<template>
    <div :class="['row', 'block-other-regions', sub_class]">
        <div class="col-l-12 col-m-12 col-s-12" v-if="title">
            <div class="container">
                <div class="row">
                    <div class="location location-info">
                        <h2 class="location-info__title light">{{ title }}</h2>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="col-l-4 col-m-4 col-s-12 region-block"
            :key="index"
            v-for="(region, index) in other_regions"
        >
            <div class="container">
                <a :href="region.link.url" :target="region.link.target">
                    <div class="col-s-12">
                        <img :src="region.image.url" />
                        <h2>{{ region.title }}</h2>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["blockdata"],
    name: "block-other-regions",
    data() {
        return {
            title: this.blockdata.title,
			other_regions: this.blockdata.other_regions,
			sub_class: this.blockdata.class
        };
    },
    mounted: function() {}
};
</script>



// WEBPACK FOOTER //
// BlockOtherRegions.vue?0585d40f